import { useTranslation } from "react-i18next";
import BreadCrump from "../tools/breadcrump"
import { getCookies } from "cookies-next";
import { useEffect, useState } from "react";
import changeUrl from "../../hoc/changeur";
import axios from "axios";
import { config } from "../../data/config";
import Swal from "sweetalert2";
import { Avatar, Button, TagInput } from 'rsuite';
import FileUpload from "../tools/chunkupload";
import HeaderOfPage from "../tools/headerOfPage";

export default function StoryDetail() {
    let cookie = getCookies();
    const [list, setList] = useState<any[]>([]);
    const [loading, setLoading] = useState<boolean>(false);
    const [error, setError] = useState<string | null>(null);

    const breadcrump = [
        {
            name: 'داشبورد',
            url: '/dashboard'
        },

        {
            name: 'ویژه',
            url: '/dashboard/Feature'
        },
        {
            name: 'استوری',
            url: null
        },
    ]
    const reloaditem = async () => {
        try {
            setError(null);
            setLoading(true);
            let res = await axios({
                method: 'get',
                url: config.url + '/v1/dashboard/story',
                headers: {
                    Authorization: 'Bearer ' + cookie['token'],
                }
            });

            let mydata = res.data;

            setList(res.data.message);
        } catch (error: any) {
            setError("امکان دریافت لیست استوری وجود ندارد. لطفا دوباره تلاش کنید.");
        } finally {
            setLoading(false);
        }
    }
    const deleteditem = async (id: any) => {
        Swal.fire({
            title: 'حذف استوری',
            text: 'آیا از حذف این استوری مطمئن هستید؟ این عملیات قابل بازگشت نیست.',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonText: 'بله، حذف شود',
            cancelButtonText: 'انصراف',
        }).then(async (result) => {
            if (result.isConfirmed) {
                try {
                    await axios({
                        method: 'delete',
                        url: config.url + '/v1/dashboard/story/' + id,
                        headers: {
                            Authorization: 'Bearer ' + cookie['token'],
                        }
                    });

                    Swal.fire('حذف شد', 'استوری با موفقیت حذف شد.', 'success');
                    reloaditem();
                } catch (error: any) {
                    Swal.fire('خطا', 'امکان حذف استوری وجود ندارد.', 'error');
                }
            }
        });
    }

    useEffect(() => {
        reloaditem();
    }, []);

    return (
        <>
            <BreadCrump data={breadcrump}></BreadCrump>
            <HeaderOfPage name="مدیریت استوری"></HeaderOfPage>

            <div className="container m-auto">
                <div className="grid grid-cols-12 gap-4 bg-slate-50 rounded-xl p-4 mt-4">
                    <div className="col-span-12 lg:col-span-4 text-right">
                        <NewStory reloaditem={reloaditem}></NewStory>
                    </div>
                    <div className="col-span-12 lg:col-span-8 text-right">
                        <div className="flex flex-col gap-3 mb-4">
                            <div className="flex flex-row items-center justify-between">
                                <h3 className="text-lg font-semibold text-slate-800">
                                    لیست استوری‌ها
                                </h3>
                                <Button
                                    appearance="ghost"
                                    loading={loading}
                                    onClick={(e) => { reloaditem() }}
                                >
                                    دوباره خوانی
                                </Button>
                            </div>
                            {error && (
                                <div className="text-sm text-red-600 bg-red-50 border border-red-100 rounded-lg px-3 py-2">
                                    {error}
                                </div>
                            )}
                        </div>
                        <div className="bg-white rounded-xl border border-slate-100 p-4 shadow-sm min-h-[200px]">
                            {loading && list.length === 0 && (
                                <div className="flex items-center justify-center h-32 text-slate-500 text-sm">
                                    در حال بارگذاری استوری‌ها...
                                </div>
                            )}
                            {!loading && list.length === 0 && (
                                <div className="flex flex-col items-center justify-center h-32 text-slate-500 text-sm">
                                    <span>هنوز استوری‌ای ثبت نشده است.</span>
                                    <span className="mt-1">از فرم سمت راست می‌توانید اولین استوری را ایجاد کنید.</span>
                                </div>
                            )}
                            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4">
                                {list.map((item: any) => {
                                    const initials = item.name ? item.name.substring(0, 2) : '';
                                    return (
                                        <div
                                            key={item.id}
                                            className="flex flex-col items-stretch gap-3 bg-slate-50 hover:bg-slate-100 transition-colors rounded-xl p-3 border border-slate-100"
                                        >
                                            <div className="flex items-center gap-3">
                                                <Avatar circle size={`lg`}>
                                                    {initials}
                                                </Avatar>
                                                <div className="flex-1 overflow-hidden">
                                                    <div className="text-sm font-semibold text-slate-800 truncate">
                                                        {item.name}
                                                    </div>
                                                    {item.username && (
                                                        <div className="text-xs text-slate-500 truncate mt-0.5">
                                                            @{item.username}
                                                        </div>
                                                    )}
                                                </div>
                                            </div>
                                            {item.text && (
                                                <div className="text-xs text-slate-600 line-clamp-2 min-h-[32px]">
                                                    {item.text}
                                                </div>
                                            )}
                                            <div className="flex flex-row gap-2 mt-1">
                                                <Button
                                                    size="xs"
                                                    appearance="primary"
                                                    className="!font-bold flex-1"
                                                    href={`/dashboard/Feature/Story/${item.id}`}
                                                >
                                                    ویرایش
                                                </Button>
                                                <Button
                                                    size="xs"
                                                    appearance="subtle"
                                                    color="red"
                                                    onClick={(e) => { deleteditem(item.id) }}
                                                >
                                                    حذف
                                                </Button>
                                            </div>
                                        </div>
                                    )
                                })}
                            </div>
                        </div>
                    </div>
                </div>
            </div>


        </>
    )
}

function NewStory({ reloaditem }: any) {
    const { t } = useTranslation();
    const styles = { width: '100%', display: 'block' };

    let cookie = getCookies();
    const [data, setData] = useState<any>({
        name: '',
        tags: [],
        keywords: '',
        description: '',
        username: ''


    });
    const [error, setError] = useState<any>(null);
    const [key, setKey] = useState<any>(1);
    const [saving, setSaving] = useState<boolean>(false);
    const setName = (name: any) => {


        var x = changeUrl(name);
        setData({ ...data, url: x });
        setData({ ...data, name: name });
    }
    const save = async () => {
        setError(null);
        setSaving(true);
        try {
            let res = await axios({
                method: 'post',
                url: config.url + '/v1/dashboard/story',
                data: data,
                headers: {
                    Authorization: 'Bearer ' + cookie['token'],
                }
            });

            let mydata = res.data;
            reloaditem();
            let x = key + 1;
            setKey(x);
            setData({
                name: '',
                tags: [],
                keywords: '',
                description: '',
                username: '',
                url: '',
                text: ''
            });
        } catch (error: any) {

            error.response.data.code != null && Swal.fire(` "${data.url}" slug is available.`);
            setError(error.response.data.message.errors);
        } finally {
            setSaving(false);
        }
    }

    const inputstyle = "py-3 px-5 block w-full border-gray-499 rounded text-sm focus:border-blue-500 focus:ring-blue-500 disabled:opacity-50 disabled:pointer-events-none";
    return (
        <div className="bg-slate-900 rounded-2xl p-5 shadow-md">
            <h4 className="text-white text-[20px] font-bold mb-2">{t(' جدید')}</h4>
            <p className="text-slate-300 text-xs mb-4">
                برای افزودن استوری جدید، اطلاعات زیر را تکمیل کنید.
            </p>
            <hr className="border-slate-700 mb-4" />

            <form key={key}>
                <div className="max-w-sm space-y-3">
                    <label className="text-white">{t('Name')}  </label>
                    <input
                        type="text"
                        className={`${inputstyle}   ${error != null && error['name'] != undefined && `bg-red-100`} `}
                        placeholder="Name"
                        value={data.name}
                        onChange={(e) => { setName(e.target.value); }}
                    />
                    {error != null && error['url'] != undefined && <small>{error['name']['message']}</small>}
                </div>
                <div className="max-w-sm space-y-3 mt-4">
                    <label className="text-white">{t('نام کاربری')}   </label>
                    <input
                    value={data.username}
                        type="text"
                        className={`${inputstyle}  text-left  ${error != null && error['username'] != undefined && `bg-red-100`}  `}
                        placeholder="Username"
                        onChange={(e) => setData({ ...data, username: e.target.value })}
                    />
                    {error != null && error['username'] != undefined && <small>{error['username']['message']}</small>}
                </div>
                <div className="max-w-sm space-y-3 mt-4">
                    <label className="text-white">{t('توضیحات')}   </label>
                    <textarea
                        value={data.text}
                        className={`${inputstyle}       ${error != null && error['url'] != undefined && `bg-red-100`}  `}

                        onChange={(e) => setData({ ...data, text: e.target.value })}
                    />
                    {error != null && error['url'] != undefined && <small>{error['url']['message']}</small>}
                </div>
                <div className="max-w-sm space-y-3 mt-4">
                    <label className="text-white">{t('تگ ها')}   </label>
                    <TagInput
                        defaultValue={data.tags}
                        onChange={(e) => setData({ ...data, tags: e })}
                        placeholder="TAGS" style={styles} />

                    {error != null && error['url'] != undefined && <small>{error['url']['message']}</small>}
                </div>
                <div className="max-w-sm space-y-3 mt-4">
                    <button type="button"
                        onClick={(e) => { save() }}
                        disabled={saving}
                        className="py-3 px-4 inline-flex items-center gap-x-2 text-sm font-medium rounded-lg border border-transparent bg-gray-100 text-gray-800 hover:bg-gray-200 focus:outline-none focus:bg-gray-200 disabled:opacity-50 disabled:pointer-events-none dark:bg-white/10 dark:text-white dark:hover:bg-white/20 dark:hover:text-white dark:focus:bg-white/20 dark:focus:text-white"
                    >
                        {saving ? t('در حال ذخیره...') : t('Save')}
                    </button>

                </div>
            </form>
        </div>
    )
}